// extracted by mini-css-extract-plugin
export var label = "_gr-2";
export var slideContainer = "_gr-0";
export var slider = "_gr-1";